/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_A4Inputs */

const en_sorter_faq_a4 = /** @type {(inputs: Sorter_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorted keys make JSON easier to read and compare. They also reduce diff noise in version control, since key order changes won't appear as modifications.`)
};

const ko_sorter_faq_a4 = /** @type {(inputs: Sorter_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬된 키는 JSON을 읽고 비교하기 쉽게 만듭니다. 또한 버전 관리에서 키 순서 변경이 수정으로 나타나지 않으므로 diff 노이즈를 줄여줍니다.`)
};

const ja_sorter_faq_a4 = /** @type {(inputs: Sorter_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソートされたキーはJSONを読みやすく、比較しやすくします。また、キー順序の変更が変更として表示されないため、バージョン管理の差分ノイズも削減されます。`)
};

/**
* | output |
* | --- |
* | "Sorted keys make JSON easier to read and compare. They also reduce diff noise in version control, since key order changes won't appear as modifications." |
*
* @param {Sorter_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_a4 = /** @type {((inputs?: Sorter_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_a4(inputs)
	if (locale === "ko") return ko_sorter_faq_a4(inputs)
	return ja_sorter_faq_a4(inputs)
});